const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogSolicitacoesAcesso(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogSolicitacoesDeAcesso`, params);
    },
    $obterRelatorioLogCSVSolicitacoesAcesso(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogSolicitacoesDeAcessoCsv`, params);
    },
    $obterRelatorioLogPDFSolicitacoesAcesso(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogSolicitacoesDeAcessoPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
